import type { FC, ReactElement } from "react";
import { RoundaboutFirstExit } from "./roundabout-first-exit";
import {
  type RoundaboutCurrentRole,
  type RoundaboutRoomUser,
  type RoundaboutTrackPendoEvent,
} from "./roundabout-markings";
import { RoundaboutTraffic } from "./roundabout-traffic";

export const RoundaboutEntrance: FC<{
  mySub: string;
  roomUsers: RoundaboutRoomUser[];
  myRole: RoundaboutCurrentRole | null;
  setMyRole: (role: RoundaboutCurrentRole) => void;
  reloadMoment: () => void;
  indicate: () => Promise<void>;
  trackPendoEvent: RoundaboutTrackPendoEvent;
}> = ({
  mySub,
  roomUsers,
  myRole,
  setMyRole,
  reloadMoment,
  indicate,
  trackPendoEvent,
}): ReactElement => {
  if (!myRole) {
    // This is rendered for the first sync, when the user first opens the moment form
    // Until they have selected a role for themselves (or left)
    // And until the room acknolwedges their presence
    return (
      <RoundaboutFirstExit
        mySub={mySub}
        setMyRole={setMyRole}
        initialUsers={roomUsers}
        trackPendoEvent={trackPendoEvent}
      />
    );
  }

  //  This is rendered once the user has established themselves
  // which triggers the subsequent sync event and therefore rerenders this component
  return (
    <RoundaboutTraffic
      mySub={mySub}
      myRole={myRole}
      setMyRole={setMyRole}
      roomUsers={roomUsers}
      reloadMoment={reloadMoment}
      indicate={indicate}
      trackPendoEvent={trackPendoEvent}
    />
  );
};
